import {
    Text,
    Box,
    Button,
    FormControl,
    FormLabel,
    FormHelperText,
    Input,
    Accordion,
    AccordionItem,
    AccordionPanel,
    AccordionButton,
    AccordionIcon,
    Textarea,
    Checkbox,
    Select,
} from '@chakra-ui/react';
import wordColor from 'utils/colors';
import CustomTable from './CustomTable';
import CustomMultipleSelectDropdown from './CustomMultipleSelectDropdown';
import { useState } from 'react';

export default function CustomAccordion({ productDetail, orderedProduct, handleChange }) {
    const [editTable, setEditTable] = useState(false);

    return (
        <Accordion defaultIndex={[0]} allowMultiple>
            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <Box as="span" flex="1" textAlign="left">
                            General
                        </Box>
                        <AccordionIcon />
                    </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                    <FormControl marginBlock="1.4rem" fontSize="sm" fontWeight="300" isRequired>
                        <FormLabel
                            color="#344054"
                            fontSize={{
                                base: '.8rem',
                                sm: '1rem',
                                md: '1rem',
                                lg: '1rem',
                            }}>
                            Enter the Product Name or Order ID
                        </FormLabel>
                        <Select
                            variant="filled"
                            name="name"
                            value={productDetail?.general?.name}
                            onChange={(e) => handleChange(e.target)}>
                            <option value="" price="" quantity="">
                                Select the item from your ordered list
                            </option>

                            {orderedProduct &&
                                Object.keys(orderedProduct).map((key, value) => {
                                    return (
                                        <option
                                            value={key}
                                            price={orderedProduct[key].price}
                                            quantity={orderedProduct[key].quantity}>
                                            {orderedProduct[key].name}
                                        </option>
                                    );
                                })}
                        </Select>
                    </FormControl>
                    <FormControl isRequired marginBottom="1.4rem">
                        <FormLabel>Enter your Preferred Product Name</FormLabel>
                        <Input
                            type="text"
                            placeholder="Balenciaga crewneck Oversized T-Shirt"
                            name="prefered_name"
                            value={productDetail?.general?.prefered_name}
                            onChange={(e) => handleChange(e.target)}
                        />
                        <FormHelperText>Give your product a short and clear name.</FormHelperText>
                    </FormControl>
                    <FormControl marginBottom="1.4rem" fontSize="sm" fontWeight="300" isRequired>
                        <FormLabel
                            color="#344054"
                            fontSize={{
                                base: '.8rem',
                                sm: '1rem',
                                md: '1rem',
                                lg: '1rem',
                            }}>
                            Product Category
                        </FormLabel>
                        <Select
                            variant="filled"
                            name="category"
                            value={productDetail?.general?.category}
                            onChange={(e) => handleChange(e.target)}>
                            <option value="">Select Category</option>
                            <option value="Clothes">Clothes</option>
                        </Select>
                    </FormControl>
                    <FormControl isRequired marginBottom="1.4rem">
                        <FormLabel>Description</FormLabel>
                        <FormHelperText marginBottom=".5rem">
                            Give your product a clear description.
                        </FormHelperText>
                        <Textarea
                            defaultValue={''}
                            name="description"
                            value={productDetail?.general?.description}
                            onChange={(e) => handleChange(e.target)}
                            placeholder="Enter a description..."
                            size="sm"
                        />
                    </FormControl>
                </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <Box as="span" flex="1" textAlign="left">
                            Inventory
                        </Box>
                        <AccordionIcon />
                    </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                    <FormControl marginBlock="1.4rem">
                        <FormLabel>SKU (Stock Keeping Unit)</FormLabel>
                        <Input
                            type="text"
                            placeholder="345678478"
                            name="prefered_sku"
                            value={productDetail?.inventry?.prefered_sku}
                            onChange={(e) => handleChange(e.target)}
                        />
                    </FormControl>
                    <FormControl marginBottom="1.4rem">
                        <FormLabel>Quantity Available</FormLabel>
                        <Input
                            type="number"
                            placeholder="50"
                            name="quantity"
                            value={productDetail?.inventry?.quantity}
                            onChange={(e) => handleChange(e.target)}
                        />
                    </FormControl>
                    <Checkbox
                        name="allow_over_sale"
                        value={productDetail?.inventry?.allow_over_sale}
                        onChange={(e) => handleChange(e.target)}>
                        Continue selling when out of stock
                    </Checkbox>
                </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <Box as="span" flex="1" textAlign="left">
                            Pricing
                        </Box>
                        <AccordionIcon />
                    </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                    <FormControl marginBlock="1.4rem">
                        <FormLabel>Regular Price</FormLabel>
                        <Input
                            type="text"
                            placeholder="₦ 1,000.00"
                            name="regular_price"
                            value={productDetail?.pricing?.regular_price}
                            onChange={(e) => handleChange(e.target)}
                        />
                    </FormControl>
                    <FormControl marginBottom="1.4rem">
                        <FormLabel>Sales Price</FormLabel>
                        <Input
                            type="text"
                            placeholder="# 1,000.00"
                            name="sale_price"
                            value={productDetail?.pricing?.sale_price}
                            onChange={(e) => handleChange(e.target)}
                        />
                    </FormControl>
                    <FormControl marginBottom="1.4rem">
                        <FormLabel>Cost per item</FormLabel>
                        <Input
                            type="text"
                            placeholder="# 1,000.00"
                            name="cost_per_item"
                            value={productDetail?.pricing?.cost_per_item}
                            onChange={(e) => handleChange(e.target)}
                        />
                        <FormHelperText>Customers won't see this.</FormHelperText>
                    </FormControl>
                    <Text>Profit: #0.00</Text>
                </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <Box as="span" flex="1" textAlign="left">
                            Variant
                        </Box>
                        <AccordionIcon />
                    </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                    <Text marginBottom=".5rem">
                        Add Product variants, we already gave you a headstart. You can select from
                        our predetermined options or you can just type and we will add it!
                    </Text>
                    <CustomMultipleSelectDropdown
                        label="Size"
                        value={['Small', 'Medium', 'Large', 'X-Large']}
                        initiaValue={productDetail?.variant?.Size}
                        callBack={handleChange}
                    />
                    <CustomMultipleSelectDropdown
                        label="Color"
                        value={wordColor}
                        initiaValue={productDetail?.variant?.Color}
                        callBack={handleChange}
                    />
                    <Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            marginBottom="1.5rem">
                            <Text display="inline">Manage product variants</Text>
                            {editTable ? (
                                <Button
                                    display="inline"
                                    background="#1b3b5f"
                                    color="#ffffff"
                                    onClick={() => setEditTable(false)}>
                                    Preview
                                </Button>
                            ) : (
                                <Button
                                    display="inline"
                                    color="#1b3b5f"
                                    variant="outline"
                                    backgroundColor="#ffffff"
                                    _hover={{
                                        color: '#1b3b5f',
                                        background: '#ffffff',
                                        border: '2px solid #1b3b5f',
                                    }}
                                    onClick={() => setEditTable(true)}>
                                    Edit
                                </Button>
                            )}
                        </Box>
                        <Box marginBottom="1.5rem">
                            <Text>
                                Variants are combinations of Product options. e.g small black shirt.
                                Here you can set pricing and inventory for each option.
                            </Text>
                        </Box>
                        <Box>
                            <CustomTable
                                editTable={editTable}
                                productDetail={productDetail}
                                handleChange={handleChange}
                            />
                        </Box>
                    </Box>
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    );
}
